var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaleasBw1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_341)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#CCCCCC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.19048,
    y: 0.190476,
    width: 35.619,
    height: 35.619,
    rx: 17.8095,
    stroke: "black",
    strokeWidth: 0.380952,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_34_341",
    maskUnits: "userSpaceOnUse",
    x: 13.9521,
    y: 8.47607,
    width: 13,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 13.9521,
    y: 8.47607,
    width: 13,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.268 26.4761V8.96253H18.9815V23.4094H26.0852V26.4761H15.268Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.268 26.4761V8.96253H18.9815V23.4094H26.0852V26.4761H15.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.268 26.4761H14.887V26.857H15.268V26.4761ZM15.268 8.96253V8.58158H14.887V8.96253H15.268ZM18.9815 8.96253H19.3625V8.58158H18.9815V8.96253ZM18.9815 23.4094H18.6006V23.7904H18.9815V23.4094ZM26.0852 23.4094H26.4661V23.0285H26.0852V23.4094ZM26.0852 26.4761V26.857H26.4661V26.4761H26.0852ZM15.6489 26.4761V8.96253H14.887V26.4761H15.6489ZM15.268 9.34348H18.9815V8.58158H15.268V9.34348ZM18.6006 8.96253V23.4094H19.3625V8.96253H18.6006ZM18.9815 23.7904H26.0852V23.0285H18.9815V23.7904ZM25.7042 23.4094V26.4761H26.4661V23.4094H25.7042ZM26.0852 26.0951H15.268V26.857H26.0852V26.0951Z",
    fill: "black",
    mask: "url(#path-3-outside-1_34_341)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_341",
    x: 0.47619,
    y: 0,
    width: 39.0476,
    height: 39.0476,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.52381
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.761905
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_341"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_341",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaleasBw1);
export default __webpack_public_path__ + "static/media/TaleasBW1.1c4612447dde255f68f64fc6ba7dacfe.svg";
export { ForwardRef as ReactComponent };